import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';
import { DamageSubCategoryRequest } from '@/main/models/request/damageSubCategoryRequest';

export abstract class IDamageSubCategoryApi {
  abstract getDamageCategoriesSubCategories(
    guidInsurer: string
  ): Promise<AxiosResponse<Result<DamageCategoryResponse[]>>>;

  abstract saveDamageSubCategory(
    request: DamageSubCategoryRequest
  ): Promise<AxiosResponse<Result<any>, any>>;

  abstract inactiveDamageSubCategory(
    guidDamageSubCategory: string
  ): Promise<AxiosResponse>;
}
